<template>
  <div id="app">
    <!-- 使用 transition 元素包裹路由出口 -->
    <!-- <transition name="fade" mode="out-in"> -->
    <router-view></router-view>
    <!-- </transition> -->
    <audio preload autoplay loop id="music"></audio>
  </div>
</template>

<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
// 引入wxjs
import wx from "weixin-js-sdk";
import routes from "@/router";
export default {
  name: "App",
  data() {
    return {
      referer: "",
    };
  },
  created() {
    // this.$getShareInfo();
    // this.$getTxtData();
    const urlParams = new URLSearchParams(window.location.search);
    let unionId = urlParams.get("unionId");
    const tmpData = {
       type: "routeChange",
        unionid: unionId,
        data: {
          path: '/',
        },
        time: this.formatTime(new Date()),
    };
    wx.miniProgram.postMessage({ data: tmpData });
    routes.afterEach((to, from, next) => {
      const eventData = {
        type: "routeChange",
        unionid: unionId,
        data: {
          path: to.path,
        },
        time: this.formatTime(new Date()),
      };
      wx.miniProgram.postMessage({ data: eventData });
    });

    // 优化：使用延迟+重试机制检测环境
    const checkEnv = () => {
      this.referer = document.referrer;
      // 多维度检测微信小程序环境
      const isMiniProgram =
        // 基础变量检测
        window.__wxjs_environment === 'miniprogram' ||
        // 微信SDK检测
        (typeof wx !== 'undefined' && typeof wx.miniProgram === Object) ||
        // User-Agent辅助检测
        navigator.userAgent.toLowerCase().includes('miniprogram');
      // 如果不是小程序环境，直接跳转指定页面
      if (!isMiniProgram) {
        window.location.href = 'https://faq.ruizhihuitech.com/';
      } else {
        // 是小程序环境的情况
        this.$store.commit('setReferer', this.referer);
        const urlParams = new URLSearchParams(window.location.search);
        const path = urlParams.get('path');
        // 如果referer是智能体地址，进行页面跳转
        this.$router.push(path);
      }
    };

    // 立即检测一次
    checkEnv();
  },
  mounted() {
    this.$applyHeights();
    window.addEventListener("resize", this.handleResize);
    // 默认播放音频
    // this.playAudio();

    // 禁用右键菜单（图片长按）
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });

    // 禁用长按选中（文字、图片）
    document.addEventListener(
      "touchstart",
      function (e) {
        if (e.touches.length > 1) {
          e.preventDefault(); // 禁止多指触摸
        }
      },
      { passive: false }
    );

    document.addEventListener("gesturestart", function (e) {
      e.preventDefault(); // 禁止双指缩放
    });

    // 优化：使用延迟+重试机制检测环境
    // const checkEnv = () => {
    //   // 多维度检测微信小程序环境
    //   const isMiniProgram =
    //     // 基础变量检测
    //     window.__wxjs_environment === 'miniprogram' ||
    //     // 微信SDK检测
    //     (typeof wx !== 'undefined' && wx.miniProgram) ||
    //     // User-Agent辅助检测
    //     navigator.userAgent.toLowerCase().includes('miniprogram');
    //
    //   if (!isMiniProgram) {
    //     window.location.href = 'https://faq.ruizhihuitech.com/';
    //   } else {
    //     this.referer = document.referrer;
    //     if (this.referer === 'https://robot.ruizhihuitech.com/') {
    //       this.$store.commit('setReferer', this.referer);
    //       console.log('Referer:', this.referer);
    //     }
    //   }
    // };
    //
    // // 立即检测一次
    // checkEnv();
    //
    // // 延迟50ms再检测一次（应对变量注入延迟）
    // setTimeout(checkEnv, 50);
    //
    // // 最多检测3次，确保覆盖各种延迟情况
    // setTimeout(checkEnv, 100);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
    methods: {
    formatTime(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${y}/${m}/${d} ${hh}:${mm}:${ss}`;
    },
  },
};
</script>

<style scoped lang="less">
/* 定义fade过渡样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
